import React from "react";

export type StatusesType =
  | { [key: string]: { [key: string]: string } }
  | undefined;

export const StatusesContext = React.createContext<StatusesType>(undefined);
